export default __webpack_public_path__ + "static/media/Zeus-small.6e361ed2.gif";